import { createFileRoute, notFound } from "@tanstack/react-router";
import { getDoctor } from "@/lib/server-functions";
import BookAppointment from "@/pages/BookAppointment";
import { getPageUrl } from "@/lib/site";

export const Route = createFileRoute("/book/$name")({
  loader: async ({ params }) => {
    try {
      const doctor = await getDoctor({ data: params.name });
      return { doctor };
    } catch {
      throw notFound();
    }
  },

  head: ({ params }) => {
    const pageUrl = getPageUrl(`/book/${encodeURIComponent(params.name)}`);

    return {
      meta: [
        { title: `Book Appointment with ${params.name} | KNMC` },
        {
          name: "description",
          content: `Book an appointment with Dr. ${params.name} at KNMC Hospital in Kathmandu, Nepal.`,
        },
        { name: "robots", content: "noindex" },
        {
          property: "og:title",
          content: `Book Appointment with ${params.name} | KNMC`,
        },
        {
          property: "og:description",
          content: `Book an appointment with Dr. ${params.name} at KNMC Hospital in Kathmandu, Nepal.`,
        },
        {
          property: "og:url",
          content: pageUrl,
        },
      ],
      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { doctor } = Route.useLoaderData();
    return <BookAppointment doctor={doctor} />;
  },
});